import { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { CSSObject, CssBaseline, Theme, Toolbar, styled } from '@mui/material';
import MuiAppBar, { AppBarProps as MuiAppBarProps } from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import MuiDrawer from '@mui/material/Drawer';

import { IInitialState } from '../../../Shared/data/FormReducer';

import { atrasIcon } from '../../../Shared/Images';
import { resultadoService } from '../../../Services/Form';
import { IUserFromStorage } from '../../../Interfaces/IUser';
import logo from '../../../Shared/Images/fit4challenge.png';
import profileImg from '../../../Shared/Images/profile.png';

interface INavigationSideBar {
  selectedPage: number;
  setSelectedPage: (state: number) => void;
  state: IInitialState;
  routes: React.ReactElement | null;
}
const drawerWidth = 240;

const openedMixin = (theme: Theme): CSSObject => ({
  width: drawerWidth,
  transition: theme.transitions.create('width', {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.enteringScreen,
  }),
  overflowX: 'hidden',
});

const closedMixin = (theme: Theme): CSSObject => ({
  transition: theme.transitions.create('width', {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  overflowX: 'hidden',
  width: `calc(${theme.spacing(7)} + 1px)`,
  [theme.breakpoints.up('sm')]: {
    width: `calc(${theme.spacing(8)} + 1px)`,
  },
});

const DrawerHeader = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'flex-end',
  padding: theme.spacing(0, 1),
  ...theme.mixins.toolbar,
}));
interface AppBarProps extends MuiAppBarProps {
  open?: boolean;
}
const AppBar = styled(MuiAppBar, {
  shouldForwardProp: (prop) => prop !== 'open',
})<AppBarProps>(({ theme, open }) => ({
  zIndex: theme.zIndex.drawer + 1,
  transition: theme.transitions.create(['width', 'margin'], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  ...(open && {
    marginLeft: drawerWidth,
    width: `calc(100% - ${drawerWidth}px)`,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  }),
}));
const Drawer = styled(MuiDrawer, { shouldForwardProp: (prop) => prop !== 'open' })(
  ({ theme, open }) => ({
    width: drawerWidth,
    flexShrink: 0,
    whiteSpace: 'nowrap',
    boxSizing: 'border-box',
    ...(open && {
      ...openedMixin(theme),
      '& .MuiDrawer-paper': openedMixin(theme),
    }),
    ...(!open && {
      ...closedMixin(theme),
      '& .MuiDrawer-paper': closedMixin(theme),
    }),
  }),
);

const NavigationSideBar: React.FC<INavigationSideBar> = (props) => {
  const navigate = useNavigate();
  const location = useLocation();

  const [open, setOpen] = useState(false);
  const [mes, setMes] = useState<number>(0);
  const [fase, setFase] = useState<string>('');
  let value = localStorage.getItem('user');
  let user: IUserFromStorage = typeof value === 'string' ? JSON.parse(value) : '';

  useEffect(() => {
    if (user && user.respondio && user.subioVideo) {
      resultadoService({
        UsuarioTestAsesoriaID: user.usuarioTestAsesoriaID ?? 0,
      })
        .then((response) => {
          setFase(response.data.data.fase);
          setMes(response.data.data.mes);
        })
        .catch(console.log);
    }
  }, [location.pathname, user]);

  return (
    <Box sx={{ display: 'flex', width: '100%' }}>
      <CssBaseline />
      <AppBar
        position="fixed"
        open={open}
        sx={{
          boxShadow: `${
            user.respondio && user ? '0px 5px 17px 2px rgb(0 0 0 / 9%)' : 'none'
          }`,
          opacity: `${user.respondio && user && user.subioVideo ? '1' : '0'}`,
          zIndex: `${user.respondio && user && user.subioVideo ? '1200' : '-1'}`,
          backgroundColor: '#fff',
          height: 'fit-content',
        }}
      >
        <Toolbar
          sx={{
            backgroundColor: 'white',
            width: '100%',
            position: 'relative',
          }}
          className="flex justify-between align-center"
        >
          {location.pathname == '/producto/2' ? (
            <div className="flex items-center justify-start">
              <img
                onClick={() => navigate('/')}
                src={atrasIcon}
                style={{
                  width: '35px',
                  height: '25px',
                  cursor: 'pointer',
                  marginRight: '5px',
                }}
              />
              <p
                style={{
                  margin: '0',
                  fontWeight: 'bold',
                  fontSize: '1.20rem',
                  color: '#000',
                }}
              >
                {(fase && mes) ? `${fase.toUpperCase()} - MES ${mes}` : ''}
              </p>
            </div>
          ) : (
            <Box sx={{ width: '91px' }} />
          )}

          <div className="w-[10%] min-w-[100px] mb-[5px]">
            {user && (
              <div>
                <img
                  onClick={() => navigate('/')}
                  src={logo}
                  width={'100%'}
                  style={{ cursor: 'pointer' }}
                  alt="logo"
                />
              </div>
            )}
          </div>
          {user && (
            <div className="w-[5%] ">
              <img
                src={profileImg}
                alt="img-profile-icon"
                style={{ height: '55px', cursor: 'pointer' }}
                onClick={() => navigate('/perfil')}
              />
            </div>
          )}
        </Toolbar>
      </AppBar>
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          p: 1,
        }}
      >
        <DrawerHeader />
        {props.routes}
      </Box>
    </Box>
  );
};

export default NavigationSideBar;
